import { render, staticRenderFns } from "./notifyDetail.vue?vue&type=template&id=034d0435&scoped=true&"
import script from "./notifyDetail.vue?vue&type=script&lang=js&"
export * from "./notifyDetail.vue?vue&type=script&lang=js&"
import style0 from "./notifyDetail.vue?vue&type=style&index=0&id=034d0435&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034d0435",
  null
  
)

export default component.exports